const estateBar = document.querySelector(".s-estate-bar")
const estateDetailIntro = document.querySelector(".s-estate-detail-intro")
const mainFooter = document.querySelector(".footer")

if (estateBar !== null && estateDetailIntro !== null) {
  const getFooterHeight = () => mainFooter?.clientHeight ?? 0

  const getEstateDetailHeight = () => estateDetailIntro?.clientHeight ?? 0

  const detectFooter = () => window.innerHeight + window.pageYOffset >= document.body.offsetHeight - getFooterHeight()

  const detectScrollPassEstateIntro = () => document.documentElement.scrollTop > getEstateDetailHeight()

  const isInLimit = () => detectScrollPassEstateIntro() && !detectFooter()

  const scrollHandle = () => {
    estateBar.classList.toggle("--active", isInLimit())
  }

  window.onscroll = scrollHandle
}
